import { graphql } from 'gatsby'
import React from 'react'

import ProfileHomePage from '../containers/ProfileHomePage'

const PortalyPage = ({ data }) => {
  return <ProfileHomePage {...data.portal} />
}

export default PortalyPage

export const query = graphql`
  query PortalyPageQuery ($firebaseId: String) {
    portal(firebaseId: {eq: $firebaseId}) {
      ...PortalData
    }
  }
`
